<template>
  <div class="neutral50" id="landing-page">
    <header-landing-new></header-landing-new>
    <v-main>
      <router-view></router-view>
    </v-main>
    <footer-landing-new></footer-landing-new>
  </div>
</template>

<script>
import HeaderLandingNew from '@/components/shared/landing-page/HeaderLandingNew.vue';
import FooterLandingNew from '../components/shared/landing-page/FooterLandingNew.vue';
export default {
  name: 'LandingLayout',
  components: { HeaderLandingNew, FooterLandingNew },
  mounted() {
    //this.$vuetify.goTo(1, {});
  },
};
</script>
